function loadItems() {
  if ($('.home').length > 0 || $('.page').length > 0 || $('.blog').length > 0 || $('.single-post').length > 0) {
    const animated = $('.fade-in');

    if ($('[data-loadingorder]').length) {
      setTimeout(function() {
        loadItemsInOrder($('[data-loadingorder]'));
      }, 1);
    }

    $(animated).on('inview', function (event, isInView) {
      if (isInView) {
        $(this).addClass('visible');
      }
    });
  }
}

function loadItemsInOrder (itemsArray, delay) {
  const delayToUse = delay || 0.4;
  const sortedItems = itemsArray.sort(function(a, b) {
    const firstItemOrder = parseInt($(a).attr('data-loadingOrder'), 10);
    const secondItemOrder = parseInt($(b).attr('data-loadingOrder'), 10);
    return firstItemOrder - secondItemOrder;
  });
  $.each(sortedItems, function(i) {
    $(sortedItems[i + 1]).removeClass('lazy-loading');
    $(sortedItems[i + 1]).css('transition-delay', ((i + 1) * delayToUse) + 's');
  });

  $(sortedItems[0]).removeClass('lazy-loading');
  const siblings = $(sortedItems[0]).attr('data-loadingSiblings');
  if (siblings) {
    $("[data-loadingSiblings='" + siblings + "']").removeClass('lazy-loading');
  }
}

export default { loadItems };



// WEBPACK FOOTER //
// ./src/js/custom/lazy-loading.js